import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import { YESNOLIST } from '@/common/constants/common';
import { useGetQueryMemberStatusListQuery } from '@/api/common';
import { TypeOfQueryMemberStatusListEnum } from '@/api/enum/common.enum';

export default function PendingIntakeSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<any>();

	const { data: queryMemberStatusList }: any = useGetQueryMemberStatusListQuery(
		TypeOfQueryMemberStatusListEnum.PENDING_INTAKE,
		{
			refetchOnMountOrArgChange: true,
		}
	);

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='isCaseStatusList'
					label={t('member.isCase')}
					options={YESNOLIST}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='statusList'
					label={t('member.status')}
					options={(queryMemberStatusList?.data || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
		</Grid>
	);
}
